import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=378bf358&scoped=true"
import script from "./addRecord.vue?vue&type=script&lang=js"
export * from "./addRecord.vue?vue&type=script&lang=js"
import style0 from "./addRecord.vue?vue&type=style&index=0&id=378bf358&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bf358",
  null
  
)

export default component.exports